import React from "react";
import { motion } from "framer-motion";
import { polarToPercent } from "./nexusGeometry";

export default function DataNode({ angle, radius, icon: Icon, color, label, value, suffix = "", testId }) {
  const pos = polarToPercent(angle, radius);
  return (
    <motion.div
      className="absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-1 z-10"
      style={pos}
      data-testid={testId}
      initial={{ opacity: 0, scale: 0.7 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      whileHover={{ scale: 1.08 }}
    >
      <div
        className="w-14 h-14 rounded-2xl flex items-center justify-center backdrop-blur-md border"
        style={{ background: `${color}14`, borderColor: `${color}40`, boxShadow: `0 0 20px ${color}25` }}
      >
        <Icon className="w-5 h-5" style={{ color }} />
      </div>
      <p className="font-mono text-sm font-bold text-white tabular-nums leading-none">
        {value !== null && value !== undefined ? `${value}${suffix}` : "—"}
      </p>
      <p className="text-[9px] uppercase tracking-wider text-slate-400 text-center leading-tight max-w-[72px]">{label}</p>
    </motion.div>
  );
}
